"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (inputStyle) => ({
    description: {
        color: inputStyle.color,
        paddingTop: 10,
        paddingBottom: 10,
        borderBottomWidth: 1,
        borderBottomColor: 'grey',
        marginLeft: 10,
    },
    separator: {
        height: 1,
        backgroundColor: 'gray',
        marginLeft: 5,
        marginRight: 5,
    },
    container: {
        flex: 0,
        height: 'auto',
        width: '100%',
    },
    textInputContainer: {
        backgroundColor: 'transparent',
        width: '100%',
        height: inputStyle.height,
        borderTopWidth: 0,
        borderBottomWidth: 0,
    },
    textInput: {
        backgroundColor: 'transparent',
        width: '100%',
        height: '100%',
        color: inputStyle.color,
        fontSize: inputStyle.fontSize,
        textAlign: (inputStyle === null || inputStyle === void 0 ? void 0 : inputStyle.textAlign) || 'left',
        placeholderTextColor: inputStyle.placeHolderColor,
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0,
        marginLeft: 0,
        marginRight: 0,
        marginTop: 0,
    },
    poweredContainer: {
        display: 'none',
    },
    listView: {
        height: 200,
        backgroundColor: 'rgba(255,255,255, .3)',
    },
    predefinedPlacesDescription: {
        color: '#1faadb',
    },
});
